<div class="scan-option">
  <div class="scan-line-1">
    <span class="scan-name" [class.done]="scan.state === 'DONE'">
      {{ scan.name }}
    </span>
    <span class="scan-state" [class.done]="scan.state === 'DONE'">
      {{ scan.state }}
    </span>
    <span class="scan-separator">|</span>
    <span class="scan-dates">
      {{ scan.launchedAt | date: 'short' }}
      →
      {{ scan.completedAt | date: 'short' }}
    </span>
  </div>
  <div class="scan-line-2">
    <span>Impacts: {{ scan.impactsCount }}</span>
    <span>Weaknesses: {{ scan.weaknessesCount }}</span>
    <span>Hosts: {{ scan.hostsCount }}</span>
  </div>
</div>
